import React, { Fragment, useState, useEffect } from "react";
import axios from "axios";
import { Row, Col, Card, Accordion, Alert } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { countries } from "../countries.js";
import { useAccount } from "wagmi";

const KYCForm = () => {
  const [localUser, setLocalUser] = useState(
    JSON.parse(localStorage.getItem("user")) || null
  );
  const [card_kyc_data, setcard_kyc_data] = useState(
    JSON.parse(localStorage.getItem("card_kyc_data")) || null
  );
  const [isLoading, setIsLoading] = useState(false);
  const { address, isConnecting, isDisconnected } = useAccount();

  //KYCFORMCONST
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");

  const [errors, setErrors] = useState({});
  const [success_message, setsuccess_message] = useState("");

  let firstName = "",
    middleName = "",
    lastName = "";
  if (localUser.fullname) {
    let parts = localUser.fullname.split(" ");
    if (parts.length > 1) {
      lastName = parts.pop();
      firstName = parts.shift();
      middleName = parts.join(" ");
    } else {
      firstName = parts[0];
    }
  }

  const formInitialState = {
    firstName:
      card_kyc_data && card_kyc_data.firstName
        ? card_kyc_data.firstName
        : localUser && localUser.firstName
        ? localUser.firstName
        : "",
    lastName:
      card_kyc_data && card_kyc_data.lastName
        ? card_kyc_data.lastName
        : localUser && localUser.lastName
        ? localUser.lastName
        : "",
    email:
      card_kyc_data && card_kyc_data.email
        ? card_kyc_data.email
        : localUser && localUser.email
        ? localUser.email
        : "",
    address_line1:
      card_kyc_data && card_kyc_data.address_line1
        ? card_kyc_data.address_line1
        : localUser && localUser.address_line1
        ? localUser.address_line1
        : "",
    address_line2:
      card_kyc_data && card_kyc_data.address_line2
        ? card_kyc_data.address_line2
        : localUser && localUser.address_line2
        ? localUser.address_line2
        : "",
    city:
      card_kyc_data && card_kyc_data.city
        ? card_kyc_data.city
        : localUser && localUser.city
        ? localUser.city
        : "",
    state:
      card_kyc_data && card_kyc_data.state
        ? card_kyc_data.state
        : localUser && localUser.state
        ? localUser.state
        : "",
    zip:
      card_kyc_data && card_kyc_data.zip
        ? card_kyc_data.zip
        : localUser && localUser.zip
        ? localUser.zip
        : "",
    country:
      card_kyc_data && card_kyc_data.country
        ? card_kyc_data.country
        : localUser && localUser.country
        ? localUser.country
        : "",
    phone_number:
      card_kyc_data && card_kyc_data.phone_number
        ? card_kyc_data.phone_number
        : localUser && localUser.phone_number
        ? localUser.phone_number
        : "",

    genderId: 0,
    idNumber: "",
    idIssuedBy: "DE",
    idExpDate: "",
    idIssueDate: "",
    idType: 0,
    idDocLang: 0,
    id_FrontSide: "",
    id_BackSide: "",
    address_TypeId: 0,
    address_IssuedBy: "",
    address_IssuedDate: "",
    address_LangId: 0,
    address_FrontSide: "",
  };

  const [formData, setFormData] = useState(formInitialState);

  // const [formData, setFormData] = useState({
  //   firstName: firstName ? firstName : "",
  //   middleName: middleName ? middleName : "",
  //   lastName: localUser.l_name ? localUser.l_name : "",
  //   address_line1: localUser.adress ? localUser.adress : "",
  //   city: localUser.city ? localUser.city : "",
  //   state: "",
  //   zip: localUser.areacode ? localUser.areacode : "",
  //   phone: "",
  //   email: localUser.email ? localUser.email : "",
  //   birth_date: localUser.dob ? localUser.dob : "",
  //   genderId: 0,
  //   idNumber: "",
  //   idIssuedBy: "DE",
  //   idExpDate: "",
  //   idIssueDate: "",
  //   idType: 0,
  //   idDocLang: 0,
  //   id_FrontSide: "",
  //   id_BackSide: "",
  //   address_TypeId: 0,
  //   address_IssuedBy: "",
  //   address_IssuedDate: "",
  //   address_LangId: 0,
  //   address_FrontSide: "",
  // });

  const nameRegex = /^[a-zA-Z\s-]+$/;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phoneRegex = /^[0-9]{9,15}$/;
  const callingCodeRegex = /^[0-9]{3}$/;

  const onlynumbers = /^[0-9]{3,15}$/;
  const stateRegex = /^[a-zA-Z\s-]+$/;

  const validateField = (name, value) => {
    switch (name) {
      case "firstName":
      case "lastName":
      case "country":
        return nameRegex.test(value) && value.length <= 22;

      case "email":
        return emailRegex.test(value) && value.length >= 3;
      case "phone":
      case "cellPhoneNumber":
        return phoneRegex.test(value);
      case "callingCode":
        return callingCodeRegex.test(value) && value.length === 3;

      case "city":
        return nameRegex.test(value) && value.length >= 3;

      case "zip":
        return value.length >= 3;

      case "state":
        return value.length >= 2 && value.length <= 25;

      case "address_IssuedBy":
        return nameRegex.test(value) && value.length <= 22;

      default:
        return true;
    }
  };

  const germanStates = [
    { name: "Baden-Württemberg", shortCode: "BW" },
    { name: "Bayern", shortCode: "BY" },
    { name: "Berlin", shortCode: "BE" },
    { name: "Brandenburg", shortCode: "BB" },
    { name: "Bremen", shortCode: "HB" },
    { name: "Hamburg", shortCode: "HH" },
    { name: "Hessen", shortCode: "HE" },
    { name: "Niedersachsen", shortCode: "NI" },
    { name: "Mecklenburg-Vorpommern", shortCode: "MV" },
    { name: "Nordrhein-Westfalen", shortCode: "NW" },
    { name: "Rheinland-Pfalz", shortCode: "RP" },
    { name: "Saarland", shortCode: "SL" },
    { name: "Sachsen", shortCode: "SN" },
    { name: "Sachsen-Anhalt", shortCode: "ST" },
    { name: "Schleswig-Holstein", shortCode: "SH" },
    { name: "Thüringen", shortCode: "TH" },
  ];

  const handleFileChange = (e) => {
    console.log("handleFileChange", e.target);
    const name = e.target.name;
    if (e.target.files.length > 0) {
      const file = e.target.files[0];

      // Might need a more reliable check for HEIC
      if (file.type === "image/heic") {
        alert("HEIC format is not supported");
        e.target.value = null;

        return;
      } else {
        let reader = new FileReader(); // Creating a FileReader instance

        reader.onload = (e) => {
          console.log("DocSet", name);
          setFormData({ ...formData, [name]: e.target.result });
        };

        reader.readAsDataURL(file); // Initiating a read operation

        reader.onloadend = () => {
          // console.log("reader.result", reader.result);
        };
      }
    } else {
      alert("No file selected");
    }
  };

  const handleCountryChange = (e) => {
    console.log("handleCountryChange", e.target.value);
    const newCountry = e.target.value;
    setSelectedCountry(newCountry);
    setFormData({ ...formData, country: newCountry, state: "" });

    if (newCountry !== "DE") {
      setSelectedState("");
    }
  };

  const handleStateChange = (e) => {
    console.log("selectedCountry", selectedCountry);
    const newState = e.target.value;
    console.log("newState", newState);
    if (selectedCountry !== "DE") {
      setSelectedState(newState);
      setFormData({ ...formData, state: newState });
    } else {
      const stateShortCode = germanStates.find(
        (state) => state.name === newState
      )?.shortCode;
      setSelectedState(newState);
      setFormData({ ...formData, state: stateShortCode });
    }
  };

  const handleChange = (e) => {
    console.log("handleChange", e.target.value);
    let { name, value } = e.target;

    const mapObject = {
      ä: "ae",
      ö: "oe",
      ü: "ue",
      ß: "ss",
    };

    if (
      name === "firstName" ||
      name === "lastName" ||
      name === "state" ||
      name === "address_line1" ||
      name === "city"
    ) {
      // Apply transformation
      value = value.replace(/ä|ö|ü|ß/gi, (matched) => mapObject[matched]);
    }

    const mapPhone = {
      "+": "00",
    };
    if (name === "phone") {
      value = value.replace(/\+/gi, (matched) => mapPhone[matched]);
    }

    const isValid = validateField(name, value);
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: isValid ? "" : "Invalid input" });
  };

  useEffect(() => {
    if (localUser) {
      console.log("LocalUser is set", localUser);
    }
  }, [localUser]);

  const handleSubmit = async (e) => {
    console.log(formData);
    e.preventDefault();
    setIsLoading(true);

    const apiEndpoint =
      "https://test.croesus-asset.management/api/submit_kyc_data";
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    try {
      var formDataToSend = new FormData();
      formDataToSend.append("id_FrontSide", formData.id_FrontSide);
      formDataToSend.append("id_BackSide", formData.id_BackSide);
      formDataToSend.append("address_FrontSide", formData.address_FrontSide);
      formDataToSend.append("user", localUser.id);
      console.log("formDataToSend", formDataToSend);
      console.log("user", localUser.id);

      const response = await fetch(
        "https://test.croesus-asset.management/api/upload",
        {
          method: "POST",
          body: formDataToSend,
        }
      );

      if (response.ok) {
        const jsonResponse = await response.json();
        console.log(jsonResponse);
        // setFormData({
        //   ...formData,
        //   id_FrontSide_path: jsonResponse.id_frontside_filename,
        //   id_BackSide_path: jsonResponse.id_backside_filename,
        //   address_FrontSide_path: jsonResponse.address_frontside_filename,
        // });
        // console.log("formData with pathes", formData);

        const fullName = `${formData.firstName} ${formData.middleName} ${formData.lastName}`;
        const dataToSend = {
          id_FrontSide_path: jsonResponse.id_frontside_filename,
          id_BackSide_path: jsonResponse.id_backside_filename,
          address_FrontSide_path: jsonResponse.address_frontside_filename,
          user: address,
          name: fullName,
          cellPhoneNumber: formData.phone,
          callingCode: "123",
          country: selectedCountry,
          countryCallingCode: selectedCountry,
          ...formData,
        };
        console.log("formdata", dataToSend);
        let formIsValid = true;
        for (const [key, value] of Object.entries(formData)) {
          if (!validateField(key, value)) {
            console.log("error");
            formIsValid = false;
            setErrors((prev) => {
              const newErrors = { ...prev, [key]: "Invalid input" };
              console.log(newErrors); // Log the new errors
              return newErrors;
            });
            setIsLoading(false);
          }
        }
        if (formIsValid) {
          try {
            const response = await axios.post(apiEndpoint, dataToSend, {
              headers,
            });
            if (response.data.success === true) {
              setsuccess_message("success");
              window.location.reload();
            }
          } catch (error) {
            console.error(`Error: ${error}`);
          }
        }
      } else {
        throw new Error("Failed to upload files");
      }
    } catch (error) {
      console.error("There was an error!", error);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  return (
    <section>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <h4>Personal Information</h4>

          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black">First Name*</label>
              <input
                type="text"
                name="firstName"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.firstName ? formData.firstName : ""}
                // value={formData.firstName}
                //  disabled={!!localUser.firstName}
                required
              />
              {errors.firstName && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.firstName}
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black">Middle Name*</label>
              <input
                type="text"
                name="middleName"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.middleName ? formData.middleName : ""}
                // value={formData.middleName}
                //  disabled={!!localUser.middleName}
              />
              {errors.middleName && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.middleName}
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">Last Name*</label>
              <input
                type="text"
                name="lastName"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.lastName ? formData.lastName : ""}
                required
              />
              {errors.lastName && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.lastName}
                </div>
              )}
            </div>
          </div>
          {/* Additional fields as per API requirements */}
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">Address Line 1*</label>
              <input
                type="text"
                name="address_line1"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.address_line1 ? formData.address_line1 : ""}
                required
              />
              {errors.address_line1 && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.address_line1}
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">City*</label>
              <input
                type="text"
                name="city"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.city}
                required
              />
              {errors.city && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.city}
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">Country*</label>
              <select
                name="country"
                value={selectedCountry}
                onChange={handleCountryChange}
                className="form-control text-black"
              >
                {countries.map((country, index) => (
                  <option key={index} value={country.isoCode}>
                    {country.name}
                  </option>
                ))}
              </select>
              {errors.country && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.country}
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">State*</label>
              {selectedCountry === "DE" ? (
                <select
                  value={selectedState}
                  onChange={handleStateChange}
                  className="form-control text-black"
                >
                  {germanStates.map((state) => (
                    <option key={state.shortCode} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  name="state"
                  className="form-control text-black"
                  type="text"
                  value={selectedState}
                  onChange={(e) => handleStateChange(e)}
                  required
                />
              )}
              {errors.state && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.state}
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">Postal Code*</label>
              <input
                type="text"
                name="zip"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.zip}
                required
              />
              {errors.zip && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.zip} (only numbers allowed)
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">Email*</label>
              <input
                type="email"
                name="email"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.email}
                required
              />
              {errors.email && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.email}
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">Phone Number*</label>
              <input
                type="text"
                name="phone"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.phone}
                required
              />
              {errors.phone && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.phone} (only numbers allowed)
                </div>
              )}
            </div>
          </div>
          {/* <div className="col-lg-6 mb-2">
          <div className="form-group mb-3">
            <label className="text-label">Cell Phone Number*</label>
            <input
              type="text"
              name="cellPhoneNumber"
              className="form-control"
              onChange={handleChange}
              value={formData.cellPhoneNumber}
              required
            />
          </div>
        </div> */}
          {/* <div className="col-lg-6 mb-2">
          <div className="form-group mb-3">
            <label className="text-label">Calling Code*</label>
            <input
              type="text"
              name="callingCode"
              className="form-control"
              onChange={handleChange}
              value={formData.callingCode}
              required
            />
          </div>
        </div> */}
          {/* <div className="col-lg-6 mb-2">
          <div className="form-group mb-3">
            <label className="text-label">Country Calling Code*</label>
            <input
              type="text"
              name="countryCallingCode"
              className="form-control"
              onChange={handleChange}
              value={formData.countryCallingCode}
              required
            />
          </div>
        </div> */}
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black  text-black">
                Birth Date*
              </label>
              <input
                type="date"
                name="birth_date"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.birth_date}
                required
              />
              {errors.birth_date && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.birth_date}
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">Gender*</label>
              <select
                name="genderId"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.genderId}
              >
                <option value="0">Male</option>
                <option value="1">Female</option>
              </select>
              {errors.genderId && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.genderId}
                </div>
              )}
            </div>
          </div>

          <h4>ID Verification</h4>

          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black">Select ID*</label>
              <select
                name="idType"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.idType}
              >
                <option value="0">Passport</option>
                <option value="2">National Id</option>
              </select>
            </div>
          </div>

          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black"> ID Language*</label>
              <select
                name="idDocLang"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.idDocLang}
              >
                <option value="0">English</option>
                <option value="1">Spanish</option>
                <option value="2">French</option>
                <option value="3">Arabic</option>
                <option value="4">Chinese</option>
                <option value="5">Japanese</option>
                <option value="6">Russian</option>
                <option value="7">Portuguese</option>
                <option value="8">German</option>
                <option value="9">Italian</option>
                <option value="10">Hindi</option>
                <option value="11">Other</option>
              </select>
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black">ID Number*</label>
              <input
                type="text"
                name="idNumber"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.idNumber}
                required
              />
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black">
                Which Country issued your ID?*
              </label>

              <select
                name="idIssuedBy"
                value={selectedCountry}
                onChange={handleCountryChange}
                className="form-control text-black"
              >
                {countries.map((country, index) => (
                  <option key={index} value={country.isoCode}>
                    {country.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black">Date Of Expiry*</label>
              <input
                type="date"
                name="idExpDate"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.idExpDate}
                required
              />
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black">Date Of Issue*</label>
              <input
                type="date"
                name="idIssueDate"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.idIssueDate}
                required
              />
            </div>
          </div>

          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black">ID Front Side*</label>
              <div className="form-file">
                <input
                  type="file"
                  name="id_FrontSide"
                  className="form-control text-black form-file-input"
                  onChange={handleFileChange}
                  accept="image/*"
                  required
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black">ID Back Side*</label>
              <div className="form-file">
                <input
                  type="file"
                  name="id_BackSide"
                  className="form-control text-black form-file-input"
                  onChange={handleFileChange}
                  accept="image/*"
                  required
                />
              </div>
            </div>
          </div>

          <h4>Address Verification</h4>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black">Select Document*</label>
              <select
                name="address_TypeId"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.address_TypeId}
              >
                <option value="0">Credit Card Statement</option>
                <option value="1">Utility Bill</option>
                <option value="2">Bank Statement</option>
                <option value="3">Bank Letter</option>
              </select>
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label text-black">
                From Whom Did You Receive This Document?*
              </label>
              <input
                type="text"
                name="address_IssuedBy"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.address_IssuedBy}
                required
              />
              {errors.address_IssuedBy && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.address_IssuedBy} (No Numbers allowed)
                </div>
              )}
              Write the name of the institution or company that issued the proof
              of address document.
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">Date of Issue*</label>
              <input
                type="date"
                name="address_IssuedDate"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.address_IssuedDate}
                required
              />
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">
                Document Language*
              </label>
              <select
                name="address_LangId"
                className="form-control text-black"
                onChange={handleChange}
                value={formData.address_LangId}
              >
                <option value="0">English</option>
                <option value="1">Spanish</option>
                <option value="2">French</option>
                <option value="3">Arabic</option>
                <option value="4">Chinese</option>
                <option value="5">Japanese</option>
                <option value="6">Russian</option>
                <option value="7">Portuguese</option>
                <option value="8">German</option>
                <option value="9">Italian</option>
                <option value="10">Hindi</option>
                <option value="11">Other</option>
              </select>
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="form-group mb-3">
              <label className="text-label  text-black">Document*</label>
              <div className="form-file">
                <input
                  type="file"
                  name="address_FrontSide"
                  className="form-control text-black form-file-input"
                  onChange={handleFileChange}
                  accept="image/*"
                  required
                />
              </div>
            </div>
          </div>
          {success_message ? (
            <div className="alert alert-success" role="alert">
              KYC submitted successfully. Reloading page.
            </div>
          ) : (
            <></>
          )}
          <div
            className="col-lg-12 "
            style={{ display: "flex", justifyContent: "center" }}
          >
            <button
              type="submit"
              className="btn btn-primary "
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "100px",
              }}
            >
              {isLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                </>
              ) : (
                <div>Submit</div>
              )}
            </button>
          </div>
        </div>
      </form>
    </section>
  );
};

export default KYCForm;
